interface IDynamicObject {
  [k: string]: any
}

// TODO [code review]: Refactor this function – current implementation is not clean. Improve readability and structure. Identified during PR #1793.
export const removeFiltersMetadata = (
  filters: IDynamicObject = {},
  opts?: {
    columnsWithIdMapping?: string[]
  },
) =>
  Object.fromEntries(
    Object.entries(filters).map(([c, v]: [string, any]) => {
      if (
        typeof v === 'string' ||
        (typeof v === 'object' && !Array.isArray(v))
      ) {
        return [c, v]
      }

      if (Array.isArray(v)) {
        const shouldUseIdMapping = opts?.columnsWithIdMapping?.includes(c)

        return [
          c,
          v.map((ele) => {
            if (typeof ele === 'number') return ele

            if (shouldUseIdMapping && 'id' in ele) {
              return String(ele.id)
            }

            return 'name' in ele ? ele.name : ele
          }),
        ]
      }

      return [c, v]
    }),
  )
